// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import Vue from 'vue/dist/vue.esm.js'//我们自己找到的带解析的版本
import App from './App'
import router from './router'
import store from './store'
import Video from 'video.js'
import moment from 'moment'
import 'video.js/dist/video-js.css'
import './style/app.css'
import './style/font_2213787_gmnkvhvunik.css'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import util from "./libs/http.js"
import CryptoJS from 'crypto-js'

Vue.prototype.$video = Video
moment.locale('zh-cn');
Vue.prototype.$moment = moment
Vue.prototype.$CryptoJS = CryptoJS

Vue.use(ViewUI);
Vue.config.productionTip = false
Vue.prototype.$http = util
Vue.prototype.$store = store


// Vue.prototype.$imgUrl = 'http://hb.ysan.club/blueapi/sys/accessory/uck/showAdminFile/'
// Vue.prototype.$baseUrl = 'http://hb.ysan.club/blueapi'
// Vue.prototype.$imgUrl = 'https://qd.xindehe.cn/blueapi/sys/accessory/uck/showAdminFile/'
// Vue.prototype.$baseUrl = 'https://qd.xindehe.cn/blueapi'
Vue.prototype.$imgUrl = 'https://www.hjbwg.mil.cn/blueapi/sys/accessory/uck/showAdminFile/'
Vue.prototype.$baseUrl = 'https://www.hjbwg.mil.cn/blueapi'

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js